export default __webpack_public_path__ + "static/sketchTogether-0f1d2a8b7b9a53ec220a8a3d35fc2ab2.svg";